<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Listado de Digitalizadores",
            items: [
                {
                text: "Digitalización",
                href: "/web/digitalizar"
                },
                {
                text: "Listado de Digitalizadores",
                active: true
                }
            ],
            usuarios:[],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            loading: false,
        };
    },
    computed:{
        rows() {
            return this.usuarios.length;
        },
        filteredData() {
            // Filtramos los datos en base al campo 'filtro' 
            return this.usuarios.filter((item) => {
                // Aquí puedes personalizar los campos a buscar
                const rut = (item.rut || '').toString().toLowerCase();
                const name = (item.name || '').toString().toLowerCase();
                const filter = this.filtro.toLowerCase();
                return rut.includes(filter) || name.includes(filter);
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        },
    },
    created(){
        this.cargarRutsUnicos();
    },
    methods: {
        cargarRutsUnicos() {
            this.loading = true;
            axios.get('/api/get_ruts_unicos').then(res=>{
                this.loading = false;
                if (res.data && Array.isArray(res.data.usuarios) && res.data.usuarios.length > 0) {
                    this.usuarios = res.data.usuarios;
                    console.log(`✓ ${res.data.total} RUTs únicos cargados`);
                } else {
                    console.warn('No hay datos disponibles:', res.data);
                    this.usuarios = [];
                }
            }).catch(err=>{
                this.loading = false;
                console.error('Error al cargar RUTs:', err.response?.status, err.message);
                if (err.response?.status === 401) {
                    console.warn('⚠️ Usuario no autenticado. Por favor inicia sesión.');
                } else {
                    console.warn('⚠️ Error: ' + (err.response?.data?.message || err.message));
                }
            });
        }
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <!-- Header UGM -->
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-list-ul font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Listado de Digitalizadores</h5>
                            <small class="text-white" style="opacity:.8;">Revisa el listado de digitalizadores activos</small>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;alumnos
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div v-if="loading" class="alert alert-info text-center mt-3">
                            <b-spinner small class="mr-2"></b-spinner>
                            Cargando registros...
                        </div>
                        <div v-else-if="usuarios.length === 0" class="alert alert-warning text-center mt-3">
                            No hay registros disponibles
                        </div>
                        <div v-else class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th style="width: 5%;">Nº</th>
                                        <th style="width: 8%;">Nombre</th>
                                        <th style="width: 10%;">RUT</th>
                                        <th style="width: 30%;">Correo Electrónico</th>
                                        <th style="width: 10%;">Telefono</th>
                                        <th style="width: 10%;">Establecimiento</th>
                                        <!-- <th style="width: 20%;">Acción</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in paginatedData" :key="index">
                                        <td>{{ item.id }}</td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.rut }}</td>
                                        <td>{{ item.email }}</td>
                                        <td>{{ item.celular }}</td>
                                        <td>{{ item.establecimiento }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="!loading && usuarios.length > 0" class="row mt-3">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>